<template>
  <div class="panel">
    <div class="content">
      <div class="title">{{ $t(`resume.sections.${resume.language || 'fr'}.candidateInfo`) }}</div>
      <div class="divider"></div>
      <div class="section">
        <div v-clickout="() => (inputSelected = '')" class="items">
          <div
            class="item"
            :class="{ grey: !resume.candidate.firstname.length }"
            @click="selectItemGeneralInfos('firstname')"
          >
            <div class="text">{{ $t('editor.candidateInfo.firstname') }}</div>
            <FireInput
              :auto-focus="true"
              name="firstname"
              class="text-input"
              :value="resume.candidate.firstname"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'firstname')"
            />
          </div>
          <div
            class="item"
            :class="{ grey: !resume.candidate.lastname.length }"
            @click="selectItemGeneralInfos('lastname')"
          >
            <div class="text">{{ $t('editor.candidateInfo.lastname') }}</div>
            <FireInput
              :auto-focus="true"
              name="lastname"
              class="text-input"
              :value="resume.candidate.lastname"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'lastname')"
            />
            <div class="check">
              <input id="hideItem" v-model="hideItem" type="checkbox" :disabled="!canEdit" />
              <label for="hideItem">{{ $t('editor.candidateInfo.hideLastname') }}</label>
            </div>
          </div>
          <div
            class="item"
            :class="{ grey: !resume.candidate.jobTitle.length }"
            @click="selectItemGeneralInfos('jobTitle')"
          >
            <div class="text">{{ $t('editor.candidateInfo.job') }}</div>
            <FireArea
              name="jobTitle"
              :value="resume.candidate.jobTitle"
              :template-div-container="'job'"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'jobTitle')"
            />
          </div>
          <div
            class="item"
            :class="{ grey: !resume.candidate.referenceLink.length }"
            @click="selectItemGeneralInfos('referenceLink')"
          >
            <div class="text">{{ $t('editor.candidateInfo.link') }}</div>
            <FireInput
              class="text-input"
              name="referenceLink"
              :value="resume.candidate.referenceLink"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'referenceLink')"
            />
          </div>
          <div class="item" :class="{ grey: !resume.candidate.email.length }" @click="selectItemGeneralInfos('email')">
            <div class="text">{{ $t('editor.candidateInfo.email') }}</div>
            <FireInput
              class="text-input"
              name="email"
              :value="resume.candidate.email"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'email')"
            />
          </div>
          <div
            class="item"
            :class="{ grey: !resume.candidate.phoneNumber.length }"
            @click="selectItemGeneralInfos('phoneNumber')"
          >
            <div class="text">{{ $t('editor.candidateInfo.phone') }}</div>
            <FireInput
              class="text-input"
              name="phone"
              :value="resume.candidate.phoneNumber"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'phoneNumber')"
            />
          </div>
          <div
            class="item"
            :class="{ grey: !resume.candidate.address.length }"
            @click="selectItemGeneralInfos('address')"
          >
            <div class="text">{{ $t('editor.candidateInfo.location') }}</div>
            <FireInput
              class="text-input"
              name="location"
              :value="resume.candidate.address"
              :disabled="!canEdit"
              @change="value => candidateChanged(value, 'address')"
            />
          </div>
        </div>
      </div>
    </div>
    <div ref="resize-handle" class="resize">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
  </div>
</template>

<script>
import PanelMixin from './mixins/PanelMixin';
import FireArea from '@/components/inputs/FireArea';
import FireInput from '@/components/inputs/FireInput';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'CandidatePanel',
  components: {
    FireArea,
    FireInput,
  },
  mixins: [PanelMixin],
  props: {
    resume: {
      type: Object,
      required: true,
    },
    scrollTo: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      inputSelected: '',
      sectionId: 'candidateInfo',
      hideItem: true,
    };
  },
  computed: {
    ...mapGetters(['currentResume', 'user']),
    canEdit() {
      if (!this.currentResume) return false;

      return [
        1, // Organization
        2, // Personal space
      ].includes(this.currentResume.workspaceType);
    },
  },
  watch: {
    hideItem(value) {
      this.itemChanged(value, 'hidden');
    },
  },
  async created() {
    if (!this.resume.items.find(i => i.type === 'candidateInfo')) {
      this.$store.dispatch('items.create', {
        resumeId: this.$route.params.id,
        item: { content: { hidden: true }, order: 0, type: 'candidateInfo' },
      });
      this.hideItem = true;
    } else {
      this.hideItem = !!this.resume.items.find(i => i.type === 'candidateInfo').content.hidden;
    }
  },
  mounted() {
    this.scrollTo();
  },
  methods: {
    selectItemGeneralInfos(item) {
      if (item) {
        this.inputSelected = item;
        this.scrollTo();
      } else {
        this.inputSelected = '';
      }
    },
    async candidateChanged(value, key) {
      const clonedResume = cloneDeep(this.resume);
      clonedResume.candidate[key] = value;

      this.$store.dispatch('resumes.candidate.edit', {
        resumeId: this.resume.id,
        candidate: clonedResume.candidate,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/inspector.scss';

.check {
  display: flex;
  align-items: center;
  margin-top: 7px;

  #hideItem {
    margin: 0 7px 0 0;
  }
}
</style>
